import { useSelector } from "react-redux";
import { useEffect, useState } from "react";

const getEmailLink = (subject, body, url) => {
  return `mailto:?subject=${encodeURIComponent(
    subject
  )}&body=${encodeURIComponent(body + "\n\n" + url)}`;
};

const getFacebookLink = (url, text) => {
  return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
    url
  )}&quote=${encodeURIComponent(text)}`; // NOTE quote no longer supported
};

const getTwitterLink = (url, text) => {
  return `https://twitter.com/intent/tweet?url=${encodeURIComponent(
    url
  )}&text=${encodeURIComponent(text)}`;
};

const getLinkedinLink = (url, text, title) => {
  return `https://linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(
    url
  )}&title=${encodeURIComponent(title)}&summary=${encodeURIComponent(text)}`; // No longer works
};

const ShareLinks = () => {
  const referralLink = useSelector((state) => state.referralLink);
  const [copied, setCopied] = useState(false);

  const text = `🚀 Ready to streamline your delivery operations? Discover Shipday – the platform for real-time last-mile delivery management! Sign up with my custom link for seamless scheduling and tracking`;

  const copyToClipboard = () => {
    navigator.clipboard.writeText(text + "\n" + referralLink);
    setCopied(true);
  };

  useEffect(() => {
    if (copied) {
      const timer = setTimeout(() => setCopied(false), 1500);
      return () => clearTimeout(timer);
    }
  }, [copied]);

  return (
    <div className="w-full">
      <div className="mx-auto" style={{ width: "fit-content" }}>
        <h4 className="text-center mb-6 share-links-header">
          Share your signup link!
        </h4>
        <div className="d-flex gap-5">
          <a
            href={getFacebookLink(referralLink, text)}
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg
              width="40"
              height="40"
              viewBox="0 0 40 40"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="20" cy="20" r="20" fill="#3b5998" />
              <path
                d="M25.7 21.1h-3.5v12.4h-5.1V21.1h-2.4v-4.3h2.4v-2.8c0-2 0.9-5.1 5.1-5.1h3.7v4.2h-2.7c-0.4 0-1 0.2-1 1.2v2.5h3.8l-0.3 4.3z"
                fill="white"
              />
            </svg>
          </a>
          <a
            href={getTwitterLink(referralLink, text)}
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg viewBox="0 0 512 512" width="40" height="40">
              <path
                d="M256 0c141.385 0 256 114.615 256 256S397.385 512 256 512 0 397.385 0 256 114.615 0 256 0z"
                fill="#000"
              />
              <path
                fill="#fff"
                d="M318.64 157.549h33.401l-72.973 83.407 85.85 113.495h-67.222l-52.647-68.836-60.242 68.836h-33.423l78.052-89.212-82.354-107.69h68.924l47.59 62.917 55.044-62.917zm-11.724 176.908h18.51L205.95 176.493h-19.86l120.826 157.964z"
              />
            </svg>
          </a>
          <a
            href={getLinkedinLink(referralLink, text, "Join Shipday!")}
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg viewBox="0 0 64 64" width="40" height="40">
              <circle cx="32" cy="32" r="32" fill="#0077B5"></circle>
              <path
                d="M20.4,44h5.4V26.6h-5.4V44z M23.1,18c-1.7,0-3.1,1.4-3.1,3.1c0,1.7,1.4,3.1,3.1,3.1 c1.7,0,3.1-1.4,3.1-3.1C26.2,19.4,24.8,18,23.1,18z M39.5,26.2c-2.6,0-4.4,1.4-5.1,2.8h-0.1v-2.4h-5.2V44h5.4v-8.6 c0-2.3,0.4-4.5,3.2-4.5c2.8,0,2.8,2.6,2.8,4.6V44H46v-9.5C46,29.8,45,26.2,39.5,26.2z"
                fill="white"
              ></path>
            </svg>
          </a>
          <a href={getEmailLink("Join Shipday!", text, referralLink)}>
            <svg
              width="40"
              height="40"
              viewBox="0 0 40 40"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="20" cy="20" r="20" fill="#7f7f7f" />
              <path
                d="M30 14L20 21L10 14V13H30V14ZM10 26V16L20 23L30 16V26H10Z"
                fill="white"
              />
            </svg>
          </a>
        </div>
      </div>
      <div className="referral-link-container">
        <textarea
          value={text + "\n" + referralLink}
          readOnly
          className="referral-link-textbox"
          rows={3}
        />
        <button onClick={copyToClipboard} className="copy-button">
          {copied ? (
            "Copied!"
          ) : (
            <>
              Copy{" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="size-6"
                width={16}
                height={16}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M8.25 7.5V6.108c0-1.135.845-2.098 1.976-2.192.373-.03.748-.057 1.123-.08M15.75 18H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08M15.75 18.75v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5A3.375 3.375 0 0 0 6.375 7.5H5.25m11.9-3.664A2.251 2.251 0 0 0 15 2.25h-1.5a2.251 2.251 0 0 0-2.15 1.586m5.8 0c.065.21.1.433.1.664v.75h-6V4.5c0-.231.035-.454.1-.664M6.75 7.5H4.875c-.621 0-1.125.504-1.125 1.125v12c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V16.5a9 9 0 0 0-9-9Z"
                />
              </svg>
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default ShareLinks;
